import type { CSSProperties } from 'react';
import type { DesignId, Site } from '../model/types';
import { DESIGNS, FONTS, byId, paletteColors } from '../model/catalog';
import { extraColours, isDark, onColor } from '../lib/color';
import { noiseCSS, textileCSS } from './art';

export type SiteMode = 'edit' | 'guest' | 'live' | 'thumb';

/** designId given => preview that design with its own suggested colours and fonts. */
export function themeFor(s: Site, designId?: DesignId) {
  const D = byId(DESIGNS, designId || s.design.base);
  if (designId && designId !== s.design.base) return { D, colors: paletteColors(D.palette), font: byId(FONTS, D.font) };
  return { D, colors: s.design.colors, font: byId(FONTS, s.design.font) };
}

export function siteStyle(s: Site, designId?: DesignId): CSSProperties {
  const { D, colors, font } = themeFor(s, designId);
  const v: Record<string, string> = {
    '--bg': colors.bg, '--ink': colors.ink, '--accent': colors.accent, '--on-accent': onColor(colors.accent),
    '--f-head': font.head, '--f-body': font.body, '--hs': String(font.hs), '--bs': String(font.bs),
    '--texture': D.texture ? noiseCSS(isDark(colors.bg)) : 'none',
  };
  if (D.id === 'indigo') v['--band'] = textileCSS(colors.accent, colors.bg);
  if (D.id === 'confetti') { const x = extraColours(colors.accent); v['--c2'] = x.c2; v['--c3'] = x.c3; }
  return v as CSSProperties;
}

export function siteClass(s: Site, designId: DesignId | undefined, mode: SiteMode) {
  const { font } = themeFor(s, designId);
  return `site d-${designId || s.design.base} btn-${s.design.button} f-${font.id}${mode === 'edit' ? ' is-edit' : ''}`;
}
